import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Samodzielny, ikonowy link-przycisk (bez widocznego tekstu).
 * Nazwa dostępna wyłącznie przez aria-label/title - dlatego `label`
 * jest wymagane i powinno pochodzić z tłumaczeń wywołującego widoku.
 */
@customElement('arti24-stats-link')
export class Arti24StatsLink extends LitElement {
    /**
     * Pozostawiamy komponent w light DOM,
     * zgodnie z pozostałymi komponentami projektu.
     */
    protected createRenderRoot(): HTMLElement {
        return this;
    }

    @property({ type: String, attribute: 'href' })
    href = '';

    @property({ type: String })
    label = '';

    render() {
        return html`
            <style>
                arti24-stats-link {
                    display: inline-flex;
                }

                arti24-stats-link .arti24-stats-link {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;

                    width: var(--arti24-stats-link-size, 2.5rem);
                    height: var(--arti24-stats-link-size, 2.5rem);

                    color: var(--arti24-stats-link-color, #2563eb);
                    text-decoration: none;

                    border-radius: 999px;
                    border: 1px solid var(--arti24-stats-link-border, rgba(37, 99, 235, 0.28));
                    background: var(--arti24-stats-link-background, rgba(37, 99, 235, 0.1));
                    box-shadow: var(--arti24-stats-link-shadow, 0 2px 7px rgba(37, 99, 235, 0.16));

                    transition:
                        background 160ms ease,
                        box-shadow 160ms ease,
                        transform 160ms ease;
                }

                arti24-stats-link .arti24-stats-link:hover,
                arti24-stats-link .arti24-stats-link:focus-visible {
                    color: var(--arti24-stats-link-hover-color, #1d4ed8);
                    background: var(--arti24-stats-link-hover-background, rgba(37, 99, 235, 0.18));
                    box-shadow: var(--arti24-stats-link-hover-shadow, 0 4px 12px rgba(37, 99, 235, 0.24));
                    transform: translateY(-2px);
                }

                arti24-stats-link .arti24-stats-link:focus-visible {
                    outline: 2px solid currentColor;
                    outline-offset: 3px;
                }

                arti24-stats-link .arti24-stats-link__icon {
                    width: var(--arti24-stats-link-icon-size, 1.3rem);
                    height: var(--arti24-stats-link-icon-size, 1.3rem);
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                    stroke-width: 2.2;
                }
            </style>

            <a class="arti24-stats-link" href=${this.href} aria-label=${this.label} title=${this.label}>
                <svg class="arti24-stats-link__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                    <path d="M18 17V9" />
                    <path d="M13 17V5" />
                    <path d="M8 17v-3" />
                </svg>
            </a>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'arti24-stats-link': Arti24StatsLink;
    }
}
